<footer id="app-mobile-footer">
    <a
        id="mobile-footer-home-link"
        [routerLink]="appRoutes.DASHBOARD"
        class="mobile-footer-item"
        aria-label="Go to Dashboard">
        <deco-icon [iconClass]="'fa-light fa-house'" [fontSize]="'1.3rem'" [margin]="'0 1rem 0 0'" [color]="'#fff'" />
        <label for="mobile-footer-home-link" id="mobile-footer-home-link-label">Home</label>
    </a>
    <button
        pButton
        type="button"
        class="nav-btn mobile-footer-item"
        id="mobile-footer-menu-btn"
        (click)="isSidebarVisible.set(!isSidebarVisible())">
        <deco-icon [iconClass]="'fa-light fa-bars'" [fontSize]="'1.3rem'" [margin]="'0 1rem 0 0'" [color]="'#fff'" />
        <label for="mobile-footer-menu-btn" id="mobile-footer-menu-btn-label">Menu</label>
    </button>
</footer>

<sidebar [id]="'app-mobile-sidebar'" [showCloseIcon]="false" [(isVisible)]="isSidebarVisible">
    <div body id="sidebar-content" trapFocus>
        <app-navigation [isSidebarCollapsed]="false"></app-navigation>
    </div>
</sidebar>
